import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import type { AvailableBehaviorCase } from '../mutations/behaviorSwitch/types';

const BASE_QUERY_KEY = 'automationTemplate/<id>/availableBehaviorCases';

export function useAvailableBehaviorCasesQuery({
	id,
	enabled = true,
	impersonationContext,
}: {
	id: string;
	enabled?: boolean;
	impersonationContext?: Api.IImpersonationContext;
}) {
	const userSession = useUserSession();
	const canQuery = typeof userSession?.webServiceHelper?.callAsync === 'function';

	return useQuery({
		enabled: enabled && !!id && canQuery,
		queryFn: () => {
			return userSession.webServiceHelper.callAsync<AvailableBehaviorCase[]>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `AutomationTemplate/${encodeURIComponent(id)}/BehaviorCase`,
					impersonationContext,
				}),
				'GET'
			);
		},
		queryKey: [BASE_QUERY_KEY, id, impersonationContext?.account?.id],
	});
}
